import React, { useState } from "react";
import "./style/basketTableStyle.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";
import EATextField from "../shared/TextField/EATextField";

interface IProps {
  handlePromotion: (promotionCode: string) => void;
  promoMessage: string;
}

const BasketCodePromotion: React.FC<IProps> = ({ handlePromotion, promoMessage }: IProps) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");

  const handleChange = (event: any) => {
    setInput(event.target.value);
  };

  return (
    <div className="basket-code-promotion">
      <EATextField
        name="discount-code"
        label={t("kod_rabatowy")}
        value={input}
        onChange={handleChange}
        fullWidth
        inputButtonTitle={t("zastosuj")}
        onInputButtonClick={() => handlePromotion(input)}
        inputButtonDisabled={input === ""}
        error={Boolean(promoMessage) && promoMessage !== t("podany_kod_jest_poprawny")}
        success={Boolean(promoMessage) && promoMessage === t("podany_kod_jest_poprawny")}
        helperText={promoMessage}
      />
    </div>
  );
};

export default BasketCodePromotion;
